module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av462-5819ece1fbec67667bedf8321ace827b.jpg";